import { makeStyles } from 'tss-react/mui';

const useStylesErrorFallbackContainer: MaterialUIStylesCallback = makeStyles()((
  theme: MainTheme,
): MaterialUIStyles => ({
  errorFallbackContainer: {
    maxWidth: 'calc(100% - 300px)',
    padding: '30px 50px',
    [theme.breakpoints.down('lg')]: {
      maxWidth: '100%',
    },
  },
  errorFallbackContainerFullWidth: {
    maxWidth: '100%',
  },
}));

export default useStylesErrorFallbackContainer;
